exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".u-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap; }\n\n.FeedbackButton {\n  padding: 8px !important;\n  overflow: visible !important;\n  color: #83baff !important;\n  font-size: 0.875rem !important;\n  font-weight: normal; }\n  .FeedbackButton:hover {\n    color: rgba(254, 254, 254, 0.9) !important; }\n  .FeedbackButton .Button-icon {\n    margin-right: 0; }\n  .FeedbackButton-tooltip {\n    width: 140px;\n    padding: 8px 16px;\n    font-size: 0.75rem;\n    line-height: 1rem; }\n", ""]);

// exports
